import { useContext, useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Sidebar from '../components/sidebar/Sidebar';
import TopNav from '../components/topnav/TopNav';

import SidebarContext from '../setup/sidebarContext';
import classes from './MainLayout.module.scss';
import { useAppSelector } from 'setup/store';
import { useTranslation } from 'react-i18next';
import BrandSelectionModal from 'components/brand/select-brand/BrandSelectionModal';
import { IBrand } from 'common/interfaces/ibrand';
import { retrieveSelectedBrandId } from 'services/db-service';
import { useSessionActions } from 'actions/session-actions';

const MainLayout = () => {
  const sidebarCtx = useContext(SidebarContext);
  const location = useLocation();
  const { t } = useTranslation();
  const { setSelectedBrand } = useSessionActions();
  const selectedBrand = useAppSelector((state) => state.sessionReducer.selectedBrand);
  const loggedInUser = useAppSelector((state) => state.appReducer.loggedInUser);
  const brands = useAppSelector((state) => state.brandReducer.brands);
  const [_selectedBrand, setBrandSelected] = useState<IBrand>();

  useEffect(() => {
    if (!selectedBrand && brands) {
      const brandId = retrieveSelectedBrandId();
      if (brandId) {
        const brand = brands?.items.find((br) => br.id === brandId);
        setBrandSelected(brand);
        setSelectedBrand(brand);
      }
    } else {
      setBrandSelected(selectedBrand || undefined);
    }
  }, [selectedBrand, brands]);

  useEffect(() => {
    if (document.body.classList.contains('sidebar__open')) document.body.classList.remove('sidebar__open');
  }, []);

  return (
    <div className={classes.container}>
      <Sidebar />
      <div className={classes.main}>
        <div className={`${classes.main__content} ${!sidebarCtx.isOpen ? classes.close_sidebar : ''} main_wrapper`}>
          <TopNav />
          {selectedBrand ? (
            <div key={location.pathname} className={classes.page__transition}>
              <Outlet />
            </div>
          ) : loggedInUser ? (
            <div>
              <BrandSelectionModal />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
